import { eventInfo } from '../data/footer.js';

// Три карточки «Дата / Место / Связь» под билетом.
// icon ссылается на встроенный SVG в AccountRouteSection.svelte (calendar/pin/chat).
export const accountRouteSection = {
  cards: [
    {
      icon: 'calendar',
      title: 'Дата и регистрация',
      description: '18 июня 2026. Регистрация на входе с 9:00.'
    },
    {
      icon: 'pin',
      title: 'Место',
      // Адрес из единого источника — чтобы в ЛК и в footer совпадали.
      description: eventInfo.address
    },
    {
      icon: 'chat',
      title: 'Связь',
      description: 'Если нужно изменить данные билета — напишите организатору.'
    }
  ]
};
